import {
  Component, ViewEncapsulation, ChangeDetectionStrategy, Input,
  Output, EventEmitter
} from '@angular/core';

import { environment as ENV } from '@environment';
import { AlertResponse } from '@shared/widgets/entities/alerts';
import { ButtonType } from '@design-system/components/molecules/button/entities/button.types';

@Component({
  selector: 'app-delete-alert-form',
  templateUrl: './delete-alert-form.component.html',
  styleUrls: ['./delete-alert-form.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DeleteAlertFormComponent {

  @Input() alert: AlertResponse;
  @Output() toggleConfirmFormEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() removeAlertEvent: EventEmitter<void> = new EventEmitter<void>();

  public iconUrl: string = '/web/travel/alert.svg';
  public completeUrl: string = ENV.resources.base_lambda_img + this.iconUrl;

  public readonly removeButtonType = ButtonType.Secondary;

  constructor() { }

  get connectionType(): string {
    return this.alert ? this.alert.direct_only ? 'DIRECT_ONLY' : 'WITH_SCALES' : 'DIRECT_ONLY';
  }

  get isOneWay(): boolean {
    return !!this.alert && !!this.alert.oneway;
  }

  get withFlexDatesInAlert(): boolean {
    return !!this.alert && !!this.alert.flex_dates;
  }

  get alertMaxPrice(): number {
    return !!this.alert && !!this.alert.price_max && +this.alert.price_max;
  }

  public toggleConfirmForm(): void {
    this.toggleConfirmFormEvent.emit();
  }

  public removeAlert(): void {
    this.removeAlertEvent.emit();
  }
}
